<template>
  <div class="grap-page">
    <main
      v-if="data && tong"
      class="trade"
    >
      <section
        v-if="cashes.length"
        class="notice-bar"
      >
        <van-icon name="volume-o" />
        <van-swipe
          :autoplay="2600"
          :show-indicators="false"
          vertical
        >
          <van-swipe-item
            v-for="(cash, index) in cashes"
            :key="cash.id || index"
          >
            <span>{{ formatCashNotice(cash) }}</span>
          </van-swipe-item>
        </van-swipe>
      </section>

      <section class="balance-card">
        <div class="balance-label">
          <img
            :src="king"
            alt=""
          >
          <span>{{ $t('investdetail.accba') }}</span>
        </div>
        <div class="balance-value">
          <span class="balance-currency">{{ utils_moneyMark() }}</span>
          <strong>{{ formatMoney(data.user.money) }}</strong>
        </div>
      </section>

      <section class="match-card">
        <img
          class="frame"
          :src="frame"
          alt=""
        >
        <div
          v-if="rankingsLoading"
          class="carousel-state"
        >
          <van-loading size="24px" />
        </div>
        <div
          v-else-if="marqueePros.length"
          class="hotel-viewport"
        >
          <div class="hotel-track">
            <article
              v-for="(hotel, index) in marqueePros"
              :key="`${hotel.title}-${index}`"
              class="hotel-card"
            >
              <div class="hotel-image">
                <img
                  v-if="!imageErrors[hotelImageKey(hotel)]"
                  :src="resolveRankingImage(hotel.img)"
                  :alt="hotel.title"
                  @error="markImageError(hotel)"
                >
                <van-icon
                  v-else
                  name="photo-o"
                />
              </div>
              <p class="hotel-title">
                {{ hotel.title }}
              </p>
              <strong>{{ formatMoney(hotel.price) }}</strong>
            </article>
          </div>
        </div>
        <div
          v-else
          class="carousel-state empty-state"
        >
          {{ $t('item.noData') }}
        </div>

        <button
          class="match-button"
          :disabled="show1"
          type="button"
          @click="grap"
        >
          {{ $t('shopd.graporder') }}
        </button>
      </section>

      <section class="statistics-card">
        <div class="statistics-head">
          <span>{{ $t('shopds.tasksnum') }}</span>
          <span>{{ $t('shopds.qcompleted') }}</span>
        </div>
        <div class="statistics-numbers">
          <strong>{{ tong.anum }}</strong>
          <strong>{{ tong.tnum }}</strong>
        </div>
        <div class="statistics-row">
          <span>{{ $t('shopds.dayincome') }}</span>
          <strong><em>{{ utils_moneyMark() }}</em>{{ formatMoney(tong.tfee) }}</strong>
        </div>
        <div class="statistics-row">
          <span>{{ $t('shopds.allimcome') }}</span>
          <strong><em>{{ utils_moneyMark() }}</em>{{ formatMoney(tong.allfee) }}</strong>
        </div>
      </section>

      <van-overlay
        :show="show3"
        :z-index="20"
        @click="show3 = false; show = true"
      >
        <div class="lucky-overlay">
          <img
            src="../images/shop2/cog.png"
            alt=""
          >
        </div>
      </van-overlay>

      <van-overlay
        :show="show1"
        :z-index="20"
        @click="show1 = false"
      >
        <div
          class="progress-overlay"
          @click.stop
        >
          <div class="progress-circle">
            <van-circle
              v-model="currentRate"
              :stroke-width="60"
              :rate="100"
              size="100%"
              :color="gradientColor"
              :text="$t('shopd.graping')"
            />
          </div>
        </div>
      </van-overlay>

      <van-overlay
        :show="show"
        :z-index="20"
        @click="show = false"
      >
        <div
          class="order-overlay"
          @click.stop
        >
          <div
            v-if="order"
            class="pop-box"
          >
            <div class="order-card">
              <div class="order-top">
                <div class="order-cover">
                  <img
                    v-if="orderImageUrl && !orderImageError"
                    :src="orderImageUrl"
                    :alt="order.title"
                    @error="orderImageError = true"
                  >
                  <van-icon
                    v-else
                    name="photo-o"
                    size="30"
                  />
                </div>
                <div class="order-title">
                  <span>{{ order.title }}</span>
                  <div>
                    <p>{{ order.pri }}</p>
                    <p>X{{ order.num }}</p>
                  </div>
                </div>
              </div>
              <div class="order-details">
                <div>
                  <span>{{ $t('shopds.onum') }}</span>
                  <span>{{ order.no }}</span>
                </div>
                <div>
                  <span>{{ $t('shopds.money') }}</span>
                  <span>{{ order.price }}</span>
                </div>
                <div>
                  <span>{{ $t('shopds.needba') }}</span>
                  <span>{{ requiredBalance }}</span>
                </div>
                <div>
                  <span>{{ $t('shopds.income') }}</span>
                  <span class="income-value">{{ order.fee }}</span>
                </div>
                <div>
                  <span>{{ $t('shopds.numtask') }}</span>
                  <span>{{ order.level }}</span>
                </div>
              </div>
            </div>
            <div class="rating-row">
              <span>{{ $t('shopds.score') }}</span>
              <van-rate
                v-model="star"
                clearable
              />
              <img
                v-if="conf"
                src="../images/shop2/cog.png"
                alt=""
              >
            </div>
            <button
              class="order-button primary"
              :disabled="submittingOrder"
              type="button"
              @click="doorder"
            >
              {{ $t('shopds.deal') }}
            </button>
            <button
              class="order-button secondary"
              type="button"
              @click="show = false"
            >
              {{ $t('shopd.cancelbtn') }}
            </button>
          </div>
        </div>
      </van-overlay>
    </main>

    <div
      v-else
      class="page-loading"
    >
      <van-loading size="28px" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Circle,
  Dialog,
  Icon,
  Loading,
  Overlay,
  Rate,
  Swipe,
  SwipeItem,
  Toast
} from 'vant';
import Fetch from '../../utils/fetch';
import Api from '../../interface';
import king from '../images/ban1/king.png';
import frame from '../images/ban1/frame.png';
import heroSunset from '../images/ban1/fe79237ab209bf72479d0dec5ef45132.png';
import heroHotel from '../images/ban1/960e5b984a99540abf2962ce49a85530.png';
import hotelThumbnail from '../images/ban1/thumbnail.png';
import hotelOverview from '../images/ban1/top.jpg';

Vue.use(Toast)
  .use(Icon)
  .use(Dialog)
  .use(Overlay)
  .use(Circle)
  .use(Rate)
  .use(Loading);

const LOCAL_RANKING_IMAGES = {
  'ban1:fe79237ab209bf72479d0dec5ef45132.png': heroSunset,
  'ban1:960e5b984a99540abf2962ce49a85530.png': heroHotel,
  'ban1:thumbnail.png': hotelThumbnail,
  'ban1:top.jpg': hotelOverview
};

export default {
  name: 'Grap',
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem
  },
  data() {
    return {
      king,
      frame,
      app: {},
      cashes: [],
      conf: false,
      currentRate: 0,
      data: null,
      gradientColor: {
        '0%': '#ffd43b',
        '100%': '#ee264d'
      },
      grapTimer: null,
      imageErrors: {},
      money: 0,
      order: null,
      orderImageError: false,
      pros: [],
      rankingsLoading: true,
      show: false,
      show1: false,
      show3: false,
      star: 0,
      submittingOrder: false,
      submitTimers: [],
      tong: null,
      vip: null,
      vips: null
    };
  },
  computed: {
    marqueePros() {
      return this.pros.length ? this.pros.concat(this.pros) : [];
    },
    orderImageUrl() {
      return this.order ? this.resolveRankingImage(this.order.pic) : '';
    },
    requiredBalance() {
      if (!this.order || !this.data || !this.data.user) {
        return '0.00';
      }

      const shortage = Number(this.data.user.money) - Number(this.order.price);
      return (shortage > 0 ? 0 : shortage).toFixed(2);
    }
  },
  created() {
    this.$parent.footer('grap');
  },
  mounted() {
    this.start();
    Fetch('/index/webconfig').then((response) => {
      this.app = response.data || {};
    });
  },
  beforeDestroy() {
    if (this.grapTimer) {
      clearTimeout(this.grapTimer);
    }
    this.submitTimers.forEach((timer) => clearTimeout(timer));
  },
  methods: {
    doorder() {
      if (this.star < 3) {
        this.$toast({
          duration: 3000,
          background: '#07c160',
          message: this.$t('shopds.lowscore')
        });
        return;
      }

      if (this.submittingOrder) {
        return;
      }

      this.submittingOrder = true;
      this.showLoadingToast('d.grap1', () => {
        this.showLoadingToast('d.grap2', () => {
          this.showLoadingToast('d.grap3', () => {
            this.dosuborder();
          });
        });
      });
    },
    dosuborder() {
      Fetch('/user/doorder', {
        id: this.order.id
      }).then(() => {
        this.show = false;
        this.submittingOrder = false;
        this.$toast({
          duration: 2000,
          background: '#07c160',
          message: this.$t('shopd.corder')
        });
        this.start();
      }).catch((error) => {
        this.submittingOrder = false;
        if (error && error.code === 0 && error.data && error.data.need) {
          Dialog.confirm({
            className: 'dialogstyle',
            confirmButtonText: this.$t('moneybag.recharge'),
            cancelButtonText: this.$t('shopd.cancelbtn'),
            message: `${this.$t('shopds.need')} ${this.utils_moneyMark()}${Number(error.data.need).toFixed(2)}`
          }).then(() => {
            this.$router.push('/invest');
          }).catch(() => {});
        }
      });
    },
    formatCashNotice(cash) {
      return String((cash && cash.text) || '')
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    },
    formatMoney(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount.toFixed(2) : '0.00';
    },
    grap() {
      if (this.show1) {
        return;
      }

      this.show1 = true;
      this.conf = false;
      this.currentRate = 0;
      this.graptime(Math.floor(Math.random() * 50) + 20);
    },
    grapdata() {
      Fetch('/user/grap').then((response) => {
        if (!response.data) {
          this.$router.push('/ordering');
          return;
        }

        this.order = response.data;
        this.orderImageError = false;
        this.star = 0;
        this.money = (Number(response.data.money) - Number(response.data.price)).toFixed(2);
        if (this.order.islucky) {
          this.$toast({
            duration: 5000,
            background: '#07c160',
            message: this.$t('shopd.lorder')
          });
          this.conf = true;
          this.show3 = true;
        } else {
          this.show = true;
        }
      });
    },
    graptime(rate) {
      this.currentRate += rate;
      if (this.currentRate < 100) {
        this.grapTimer = setTimeout(() => {
          this.graptime(rate);
        }, 1000);
        return;
      }

      this.grapTimer = null;
      this.show1 = false;
      this.grapdata();
    },
    hotelImageKey(hotel) {
      return String((hotel && hotel.img) || 'unknown');
    },
    markImageError(hotel) {
      this.$set(this.imageErrors, this.hotelImageKey(hotel), true);
    },
    resolveRankingImage(image) {
      if (LOCAL_RANKING_IMAGES[image]) {
        return LOCAL_RANKING_IMAGES[image];
      }
      if (/^https?:\/\//i.test(image || '') || /^\/\//.test(image || '')) {
        return image;
      }

      const baseUrl = this.app.domain || Api.commonUrl || '';
      if (!baseUrl || typeof image !== 'string' || !image.trim()) {
        return '';
      }
      const path = image.trim().replace(/\\/g, '/').replace(/^(\.\/|\/)+/, '');
      return `${baseUrl.replace(/\/$/, '')}/${path}`;
    },
    showLoadingToast(messageKey, callback) {
      const duration = Math.floor(Math.random() * 1000) + 300;
      Toast.loading({
        duration,
        forbidClick: true,
        className: 'toastc',
        loadingType: 'spinner',
        message: this.$t(messageKey)
      });
      const timer = setTimeout(() => {
        this.submitTimers = this.submitTimers.filter((item) => item !== timer);
        callback();
      }, duration);
      this.submitTimers.push(timer);
    },
    start() {
      this.rankingsLoading = true;
      Fetch('/user/basicinfo').then((response) => {
        const result = response.data || {};
        this.data = result;
        this.tong = result.tong || {};
        this.vip = result.vip;
        this.vips = result.vips;
        this.cashes = Array.isArray(result.cashes) ? result.cashes : [];
        this.pros = Array.isArray(result.pros) ? result.pros : [];
        this.money = (Number(result.user && result.user.money) - Number(result.orderprice)).toFixed(2);
      }).catch(() => {
        this.pros = [];
      }).then(() => {
        this.rankingsLoading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.grap-page {
  min-height: 100vh;
  color: #17202d;
}

.trade {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 20px 16px 92px;
}

.notice-bar {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 17px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, .88);
  border-radius: 14px;
  background: rgba(255, 255, 255, .74);
  box-sizing: border-box;
  color: #5b616a;
  font-size: 14px;
  box-shadow: 0 12px 30px rgba(27, 32, 47, .07);

  .van-icon {
    flex: 0 0 auto;
    margin-right: 12px;
    color: #b89151;
    font-size: 20px;
  }

  .van-swipe {
    flex: 1;
    height: 50px;
    line-height: 50px;
  }

  span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.balance-card {
  position: relative;
  margin-top: 18px;
  padding: 20px 19px 18px;
  overflow: hidden;
  border: 1px solid rgba(255, 230, 186, .28);
  border-radius: 18px;


  &::after {
    position: absolute;
    top: -46px;
    right: -24px;
    width: 142px;
    height: 142px;
    border: 1px solid rgba(216, 179, 109, .42);
    border-radius: 50%;
    content: '';
  }
}

.balance-label {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, .8);
  font-size: 15px;
  letter-spacing: .2px;

  img {
    width: 22px;
    height: 22px;
    margin-right: 8px;
    object-fit: contain;
  }
}

.balance-value {
  display: flex;
  align-items: baseline;
  position: relative;
  z-index: 1;
  margin-top: 12px;

  strong {
    color: #fff;
    font-size: 26px;
    line-height: 1;
    letter-spacing: .6px;
  }

  .balance-currency {
    margin-right: 10px;
    color: #dcb976;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .7px;
  }
}

.match-card {
  position: relative;
  margin-top: 39px;
  padding: 39px 0 20px;
  overflow: visible;
  border: 1px solid rgba(35, 47, 68, .08);
  border-radius: 20px;
  background: rgba(255, 255, 255, .94);
  box-shadow: 0 20px 40px rgba(27, 32, 47, .1);

  &::before {
    position: absolute;
    top: 25px;
    right: 22px;
    left: 22px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(184, 145, 81, .5), transparent);
    content: '';
  }
}

.frame {
  position: absolute;
  top: -37px;
  left: 50%;
  z-index: 2;
  width: 92px;
  height: 69px;
  transform: translateX(-50%);
  object-fit: contain;
  filter: saturate(.78) drop-shadow(0 7px 7px rgba(22, 29, 40, .18));
}

.hotel-viewport {
  width: auto;
  margin: 0 14px;
  overflow: hidden;
}

.hotel-track {
  display: flex;
  width: max-content;
  padding: 0 0 6px;
  animation: hotel-marquee 36s linear infinite;
}

.hotel-card {
  flex: 0 0 164px;
  width: 164px;
  padding: 7px 7px 13px;
  margin-right: 14px;
  border: 1px solid #ede8df;
  border-radius: 16px;
  background: #fffdf9;
  box-sizing: border-box;
  color: #1c2636;
  text-align: center;
}

.hotel-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 148px;
  height: 143px;
  overflow: hidden;
  border-radius: 12px;
  background: #e9e9e7;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .van-icon {
    color: #a9b1ba;
    font-size: 36px;
  }
}

.hotel-title {
  min-height: 20px;
  margin: 10px 0 5px;
  overflow: hidden;
  color: #59616c;
  font-size: 14px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hotel-card > strong {
  display: block;
  color: #17202d;
  font-size: 19px;
  line-height: 24px;
  letter-spacing: .2px;
}

.carousel-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 191px;
}

.empty-state {
  color: #8b8b94;
  font-size: 14px;
}

.match-button,
.order-button {
  border: 0;
  cursor: pointer;
  font: inherit;
}

.match-button {
  display: block;
  width: calc(100% - 36px);
  height: 50px;
  margin: 18px 18px 0;
  border-radius: 12px;
  background: linear-gradient(105deg, #d81d43 0%, #f3315c 54%, #d92048 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: .4px;
  box-shadow: 0 12px 20px rgba(211, 29, 68, .25);

  &:disabled {
    opacity: .65;
  }
}

.statistics-card {
  margin-top: 24px;
  overflow: hidden;
  border: 1px solid rgba(35, 47, 68, .08);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 35px rgba(27, 32, 47, .08);
}

.statistics-head,
.statistics-numbers {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: center;
}

.statistics-head {
  height: 58px;
  align-items: center;
  border-bottom: 1px solid rgba(214, 174, 105, .4);
  background: linear-gradient(105deg, #121b29, #26354b);
  color: rgba(255, 255, 255, .95);
  font-size: 14px;
  letter-spacing: .2px;
}

.statistics-numbers {
  min-height: 64px;
  align-items: center;
  border-bottom: 1px solid #ece9e3;
  background: #fff;
  color: #1e2a3a;
  font-size: 19px;
}

.statistics-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 58px;
  padding: 0 18px;
  border-bottom: 1px solid #ece9e3;
  box-sizing: border-box;
  color: #505965;
  font-size: 14px;

  &:last-child {
    border-bottom: 0;
  }

  strong {
    color: #202b3a;
    font-size: 17px;
  }

  em {
    color: #b89151;
    font-size: 12px;
    font-style: normal;
  }
}

.page-loading,
.progress-overlay,
.order-overlay,
.lucky-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-loading {
  min-height: 100vh;
}

.progress-overlay {
  width: 100%;
  height: 100%;
}

.progress-circle {
  width: 120px;
  height: 120px;
}

.lucky-overlay {
  width: 100%;
  height: 100%;

  img {
    width: 90vw;
    max-width: 500px;
  }
}

.order-overlay {
  min-height: 100%;
  padding: 48px 15px;
  box-sizing: border-box;
}

.pop-box {
  width: 100%;
  max-width: 520px;
  padding: 6px;
  border: 1px solid rgba(216, 185, 118, .55);
  border-radius: 16px;
  background: #fffdf9;
  box-shadow: 0 24px 48px rgba(8, 15, 25, .28);
  box-sizing: border-box;
}

.order-card {
  padding: 10px;
  margin: 5px;
  border: 1px solid #eee8df;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, .05);
}

.order-top {
  display: flex;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #8c8c8c;
}

.order-cover {
  display: flex;
  flex: 0 0 95px;
  align-items: center;
  justify-content: center;
  width: 95px;
  height: 95px;
  overflow: hidden;
  border-radius: 8px;
  background: #eef0f3;
  color: #aab1bb;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.order-title {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  justify-content: space-between;

  > span {
    display: -webkit-box;
    overflow: hidden;
    color: #37475a;
    font-size: 14px;
    line-height: 20px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  > div {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;

    p {
      margin: 0;
    }

    p:last-child {
      color: #034aff;
      font-size: 13px;
    }
  }
}

.order-details {
  padding-top: 7px;
  color: #37475a;
  font-size: 13px;

  > div {
    display: flex;
    justify-content: space-between;
    min-height: 22px;
    align-items: center;
  }

  span:last-child {
    color: #232f3e;
  }

  .income-value {
    color: #ee264d;
  }
}

.rating-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 15px;
  font-size: 16px;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
}

.order-button {
  display: block;
  width: calc(100% - 20px);
  height: 42px;
  margin: 12px 10px;
  border-radius: 10px;
  font-size: 16px;

  &.primary {
    background: linear-gradient(105deg, #d81d43, #f3315c);
    color: #fff;
  }

  &.secondary {
    background: #d9d9d9;
    color: #37475a;
  }

  &:disabled {
    opacity: .65;
  }
}

::v-deep .van-circle__text {
  color: #fff;
}

@keyframes hotel-marquee {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .hotel-track {
    animation: none;
  }
}

@media (max-width: 340px) {
  .trade {
    padding-right: 10px;
    padding-left: 10px;
  }

  .hotel-card {
    flex-basis: 150px;
    width: 150px;
  }

  .hotel-image {
    width: 134px;
    height: 130px;
  }

  .statistics-head,
  .statistics-row {
    font-size: 14px;
  }
}

/* Keep the order flow unchanged while using the same Airbnb-inspired account
 * language as the home and profile pages. */
.grap-page {
  color: #222;
}

.trade {
  padding: 16px 16px 92px;
}

.notice-bar {
  height: 46px;
  padding: 0 14px;
  border-color: #ebebeb;
  border-radius: 14px;
  background: #fff;
  box-shadow: none;
  color: #717171;
  font-size: 13px;

  .van-icon {
    margin-right: 10px;
    color: #ff385c;
    font-size: 19px;
  }

  .van-swipe {
    height: 46px;
    line-height: 46px;
  }
}

.balance-card {
  margin-top: 14px;
  padding: 19px 18px 17px;
  border: 0;
  border-radius: 20px;
 background: linear-gradient(125deg, #1d304d, #355678 72%, #4a617f);
 box-shadow: 0 10px 24px rgba(25, 46, 75, 0.18);
 color: #fff;

  &::after {
    top: -48px;
    right: -23px;
    border-color: rgba(255, 255, 255, .17);
  }
}

.balance-label {
  color: rgba(255, 255, 255, .65);
  font-size: 14px;

  img {
    width: 20px;
    height: 20px;
    margin-right: 7px;
    filter: grayscale(1) brightness(5);
  }
}

.balance-value {
  margin-top: 11px;

  strong {
    font-size: 27px;
    letter-spacing: -.2px;
  }

  .balance-currency {
    color: #ffe0e6;
    font-size: 12px;
  }
}

.match-card {
  margin-top: 18px;
  padding: 14px 0 19px;
  overflow: hidden;
  border-color: #ebebeb;
  border-radius: 20px;
  background: #fff;
  box-shadow: none;

  &::before {
    display: none;
  }
}

.frame {
  display: none;
}

.hotel-viewport {
  margin: 0 12px;
}

.hotel-track {
  padding-bottom: 3px;
}

.hotel-card {
  flex-basis: 164px;
  width: 164px;
  padding: 6px 6px 11px;
  margin-right: 11px;
  border-color: #ebebeb;
  border-radius: 14px;
  background: #fff;
}

.hotel-image {
  width: 150px;
  height: 136px;
  border-radius: 10px;
}

.hotel-title {
  margin: 8px 0 3px;
  color: #484848;
  font-size: 13px;
}

.hotel-card > strong {
  color: #222;
  font-size: 17px;
}

.match-button {
  width: calc(100% - 28px);
  height: 48px;
  margin: 17px 14px 0;
  border-radius: 13px;
  background: #ff385c;
  box-shadow: 0 9px 18px rgba(255, 56, 92, .2);
  font-size: 16px;
}

.statistics-card {
  margin-top: 18px;
  border-color: #ebebeb;
  border-radius: 20px;
  box-shadow: none;
}

.statistics-head {
  height: 50px;
  border-bottom-color: #ebebeb;
  background: #fff;
  color: #717171;
  font-size: 13px;
}

.statistics-numbers {
  min-height: 61px;
  color: #222;
  font-size: 20px;
}

.statistics-row {
  min-height: 54px;
  padding: 0 16px;
  border-bottom-color: #f0f0f0;
  color: #717171;
  font-size: 13px;

  strong {
    color: #222;
    font-size: 16px;
  }

  em {
    color: #e31c5f;
    font-size: 11px;
  }
}

.pop-box {
  padding: 5px;
  border-color: #ebebeb;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 20px 46px rgba(34, 34, 34, .22);
}

.order-card {
  border-color: #ebebeb;
  border-radius: 13px;
  box-shadow: none;
}

.order-top {
  border-bottom-color: #ebebeb;
}

.order-cover {
  border-radius: 10px;
}

.order-title > span,
.order-details {
  color: #484848;
}

.order-title > div p:last-child,
.order-details .income-value {
  color: #e31c5f;
}

.order-details span:last-child {
  color: #222;
}

.rating-row {
  color: #222;
}

.order-button {
  border-radius: 12px;

  &.primary {
    background: #ff385c;
  }

  &.secondary {
    background: #f7f7f7;
    color: #484848;
  }
}

@media (max-width: 340px) {
.trade {
    padding-right: 10px;
    padding-left: 10px;
  }

  .hotel-card {
    flex-basis: 150px;
    width: 150px;
  }

  .hotel-image {
    width: 136px;
    height: 126px;
  }
}



.notice-bar,
.match-card,
.statistics-card {
  background: rgba(255, 255, 255, .94);
}

</style>
